import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0c2e459e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c2e459e')) {
      api.createRecord('0c2e459e', component.options)
    } else {
      api.reload('0c2e459e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0c2e459e&", function () {
      api.rerender('0c2e459e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/profile/screens/ProfileScreen/index.vue"
export default component.exports